<template>
  <div class="detail-content-wrapper">
    <div class="detail-wrapper">
      <div class="headerdetail">
        <img :src="headImgUrl" alt="">
      </div>
      <div class="detail-introduce">
        <div class="detail-introduce-left">
          <span class="detail-introduce-left-username">{{donateName}}</span>
        </div>
        <div class="detail-introduce-right">
          <span class="detail-introduce-right-age">{{donateage}}岁</span>
          <span class="detail-introduce-right-point" style="margin: 0 5px">·</span>
          <span class="detail-introduce-right-glass">{{donateclass}}</span>
        </div>
      </div>
    </div>
    <div class="detail" v-html="detailObject">
    </div>
    <van-goods-action>
      <van-goods-action-icon  class="iconfont icon-Vector1" text="首页" @click="onClickIcon" color="#AB74B1" >
      </van-goods-action-icon>
      <div v-if="stuId == 16 || stuId ==15" style="width: 100%">
        <van-goods-action-button
            class="detail-donate-text"
            type="danger"
            text="已认捐"
            :disabled=true
        />
      </div>
      <div v-else style="width: 100%">
        <van-goods-action-button
            class="detail-donate-text"
            type="danger"
            text="我要认捐"
            @click="donateOnclick"
            v-if="enabled!=1 && enabled!=2"
        />
        <van-goods-action-button
            class="detail-donate-text"
            type="danger"
            text="爱心正在认捐中..."
            :disabled=true
            v-if="enabled==1"
        />
        <van-goods-action-button
            class="detail-donate-text"
            type="danger"
            :text="donateUsername+'已认捐'"
            v-if="enabled==2"
            :disabled=true
        />
      </div>

    </van-goods-action>
    <!--   金额提示 -->
    <van-action-sheet
        v-model="donationShow"
    >
      <div class="donation">
        <div class="donation-num">
          <div class="donation-num-let">
            <span style="color: #BDB4BE;">捐赠金额</span>
          </div>
          <div class="donation-num-right">
            <span>3750元</span>
          </div>
        </div>
<!--        <div class="donation-contract">-->
<!--          <van-checkbox v-model="checkbox" shape="shape" checked-color="#C199C6">-->
<!--            同意<span style="color: #C199C6;text-decoration:underline;" @click="agreement">用户捐款协议</span>-->
<!--          </van-checkbox >-->
<!--        </div>-->
        <div class="submit" @click="onHandler">
          <span>确认捐款</span>
        </div>
      </div>

    </van-action-sheet>
    <van-popup v-model="loginshow" class="loginPop">
      <van-form  ref="form" @submit="loginSubmit">
        <van-field
            v-model="customNum"
            label="捐赠金额(元)"
            :disabled=true
        />
        <van-field
            v-model="userObject.username"
            name="username"
            placeholder="姓名"
            maxlength="6"
            :rules="[{ required: true, message: '请填写姓名' }]"
        >
          <i slot="left-icon" class="iconfont icon-yonghu"></i>
        </van-field>
        <van-field
            v-model="userObject.tel"
            name="tel"
            placeholder="请输入手机号"
            :rules="telRules"
            type="number"
            maxlength="11"
        >
          <i slot="left-icon" class="iconfont icon-shouji"></i>
        </van-field>


        <van-field
            v-model="userObject.code"
            name="code"
            placeholder="请输入验证码"
            :rules="codeRules"
            type="number"
            maxlength="4"
            class="codeRules"
        >
          <i slot="left-icon" class="iconfont icon-yanzhengma" ></i>
          <template #button>
            <van-button  round  size="small" type="primary" v-show="pstatus === 0"  class="" @click="smsHandler"  native-type="button" >发送验证码</van-button>
            <van-button round   size="small" type="primary" v-show="pstatus === 1" @click="smsHandler" native-type="button"  >重新获取</van-button>
            <van-button round   size="small" type="primary" v-show="pstatus === 2" native-type="button">{{times}}s</van-button>
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-popup>
    <van-popup v-model="show">
        <van-form  ref="form">
          <van-field
              v-model="donateName"
              label="被捐赠人"
              :disabled=true
          />
          <van-field
              v-model="donateNum"
              label="捐赠金额"
              :disabled=true
          />
            <van-field
                v-model="username"
                name="username"
                label="捐赠人"
                placeholder="请输入姓名"
                :rules="[{ required: true}]"
            />
            <van-field
                v-model="mobile"
                label="手机号"
                name="mobile"
                placeholder="请输入手机号"
                :rules="telRules"

            />
              <van-field
                  v-model="code"
                  center
                  clearable
                  label="短信验证码"
                  placeholder="请输入短信验证码"
                  :rules="codeRules"
                 >
                <template #button>
                  <van-button size="small" type="primary" v-show="pstatus === 0" @click="smsHandler">发送验证码</van-button>
                  <van-button size="small" type="primary" v-show="pstatus === 1" @click="smsHandler">重新获取</van-button>
                  <van-button size="small" type="primary" v-show="pstatus === 2">{{times}}s</van-button>
                </template>
              </van-field>
           <div style="margin: 16px;">
          <van-button round block type="info" @click="handleSubmit">提交</van-button>
        </div>
      </van-form>

      </van-popup>
    <div class="detailtop" @click="backTop">
      <img src="/top.png" alt="">
    </div>
    <div class="backTo" @click="backTo">
        <img src="../../assets/back.png" alt="" class="backToImg">
    </div>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import {
  getdataInfoDetail,
  sendMessage,
  getdataInfoUpdate,
  stuInfo,
  PayDonation,
  proUsersave,
  login
} from '../../api/index'
import { Dialog,Toast } from 'vant';
export default {
  name: "index",
  data(){
    return{
      customNum:3750,
      loginshow:false,
      timeoutr:null,
      flag:true,
      donationShow:false,
      checkbox:false,
      headImgUrl:'',
      donateName:'',
      donateage:'',
      donateclass:'',
      donateNum:'3750',
      detailObject:null,
      id:0,
      proId:0,
      stuId:0,
      enabled:null,
      show:false,
      username:'',
      mobile:'',
      pstatus:0,
      times:60,
      code:'',
      backCode:'',
      scrollTop:0,
      donateUsername:'',
      studentName:'',
      userObject:{
        username:'',
        tel:'',
        code:'' //验证码
      },
      telRules: [{
        required: true,
        message: '手机号不能为空',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: value => {
          return /^1[3456789]\d{9}$/   .test(value)

        },
        message: '手机格式错误',
        trigger: 'onBlur'
      }],
      codeRules: [{
        required: true,
        message: '请填写验证码',
        trigger: 'onBlur'
      }]
    }
  },
  computed:{
    ...mapState(['user'])
  },
  mounted(){
    const id = this.$route.query.id
    console.log(id)
    const proId = this.$route.query.proId
    this.id = id
    this.proId = proId
    this.stuId = this.$route.query.stuId
    this.studentName = this.$route.query.stuname
    this.getDataInfo(id)
  },
  methods:{
     agreement(){
      this.$router.push('/agreement')
    },
    backTo(){
      this.$router.go(-1)
    },
    async getDataInfo(id){
      Toast.loading({
        duration: '',
        message: '加载中...',
        forbidClick: true,
      });
      const dataInfo = await stuInfo({psId:id})
      if(dataInfo.code == 200) {
        let dataObj = dataInfo.data
        this.detailObject = dataObj.psInfo
        this.enabled = dataObj.ordState
        this.donateName = dataObj.stuName
        this.headImgUrl = dataObj.phoLink
        this.donateage=dataObj.stuAge
        this.donateclass = dataObj.clsName
        this.donateUsername = dataObj.userName

      }
      Toast.loading({
        duration: 100,
        message: '加载中...',
        forbidClick: true,
      });

    },
    smsHandler(){
      // 局部表单验证
      this.$refs.form.validate('tel').then(() => {
        this.sendMessageInfo(this.userObject.tel)
      })

    },
    async sendMessageInfo(tel){
      try {
        await this.$refs.form.validate('tel')
        const data = await sendMessage(tel)
        if(data.code == 200){
          this.backCode = data.data
          Toast.success('短信发送成功，请查看');
          this.countDown()
        }
      }catch (e) {
        return console.log('手机格式输入错误',e)
      }

      //
      // else {
      //   Toast.fail('手机号不能为空');
      // }
    },
    onHandler(){
      // if(!this.checkbox){
      //   Toast('请先勾选协议')
      //   return
      // }

      this.donationShow = false
      if(!this.user){
        this.loginshow = true
      }else{
        this.throlttle()
      }
    },
    //倒计时修改
    countDown:function(){
      var that = this;
      that.pstatus = 2;
      that.times = 60;
      var st = setInterval(function(){
        that.times = that.times - 1;
        if(that.times === 0) {
          clearInterval(st);
          that.pstatus = 1;
        }
      },1000);
    },
    /*保存用户人信息*/
    async getUserInfo(){
      // let mobile = localStorage.getItem('mobile') ? localStorage.getItem('mobile') : this.mobile
      const userInfo = await proUsersave(this.user.tel)

    },
    //返回首页
    onClickIcon(){
      this.$router.push({path:'/'})
    },
    //我要捐款
    donateOnclick(){
      // if(!this.user){
      //   Toast.success('请先登录')
      //   this.$router.push('/login')
      //   return
      // }
      this.donationShow = true
      // this.show = true
      // this.confirmNum()
    },

    handleSubmit(){
      this.$refs.form.validate().then(() => {
        if(this.backCode != this.code){
          Toast('验证码输入不正确');
          return
        }
        this.show = false
        this.confirmNum()
      }).catch(() => {

      })
    },
    confirmNum(){
      Dialog.confirm({
        title: '',
        message: `你确认为${ this.studentName}认捐3750元吗？`,
      }).then(() => {
        if(this.flag){
          this.flag = false
          this.onSubmit()
          Toast.loading({
            duration: '',
            message: '提交中...',
            forbidClick: true,
          });
          this.timeoutr =  setTimeout(() =>{
            this.flag = true
          },5000)

        }

      }).catch(() => {
        // on cancel
        console.log('取消认捐')
      });


    },
    throlttle(){
      if(this.flag) {
        this.flag = false
        this.onSubmit()
        this.timer = setTimeout(() => {
          this.flag = true
        }, 5000)
      }
    },
    backTop() {
      let that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if(that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    async onSubmit(){
       const data = await PayDonation({"proId":this.proId,'puId':this.user.puId,'ordAmount':this.donateNum,'stuId':this.stuId,'returnUrl':'https://charity.sohochina.com/#/pay','psId':this.id })
        if(data.code == 500){
          Toast(data.msg);
        }else {
          this.orderId = data.data.ordId
          window.localStorage.setItem('ordId',this.orderId)
          console.log(this.orderId)
          // this.$store.commit('setId',data.data.ordId)
          window.location.href= data.data.payUrl
        }

    },
    async loginSubmit() {
      const user = this.userObject
      this.$refs.form.validate().then(() => {
        if(this.backCode != this.userObject.code){
          Toast('验证码输入不正确');
          return
        }
      }).catch(() => {

      })
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration:0
      });
      try {
        const res = await login(user)
        if(res.code == 200){
          this.$store.commit('setUser',res.data)
          this.throlttle()
        }else {
          Toast('提交失败，请重试')
        }

      }catch (err){
        if(err.response.status == 400){
          console.log('手机号或者验证码错误')
        }else{
          console.log('登录失败，请重试',err)
        }

      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeoutr)
    this.timeoutr =  null
  }

}
</script>

<style >
.van-submit-bar__button--danger{
  background: linear-gradient(to right,#c996c9,#c996c9) !important;
}
.van-goods-action-button--danger{
  background: linear-gradient(to right,#c996c9,#c996c9) !important;
}
.van-popup--center{
  border-radius: 10px;
}
.van-submit-bar{
  padding-top: 10px;
}
.van-button--danger{
  background-color:#A471AA !important;
}
/*.van-button__text{*/
/*  font-size: 30px;*/
/*}*/
.van-button--primary{
  background-color:#c996c9 !important;
  border: 1px solid #c996c9 !important;
}
.van-button--small{
  width: 160px;
}
.van-goods-action{
  z-index: 999 !important;;
}

.van-field__control:disabled{
  color: #000 !important;
  -webkit-text-fill-color:#000 !important;
}
/deep/.van-goods-action-button--danger{
  background-color:#c996c9 !important;
}
 .van-field__label{
  color: #000 !important;
}
/*.van-form{*/
/*  width: 680px;*/
/*  height: 620px;*/
/*  padding-top: 20px;*/
/*}*/
.van-button--info{
  background-color:#c996c9 !important;
  border: 1px solid #c996c9 !important;
}
.document{
  /*padding: 0px 40px 0;*/
}
.image-wrapper{
  width: 100%;
  display: block;
}
.detail-content-wrapper{
  background:#F7F4F8;
  position: relative;
}
.detailtop{
  position: absolute;
  bottom: 180px;
  right: 40px;
  z-index: 1;
}
.detailtop img{
  width: 76px;
  height:76px;
}
.detail-wrapper{
  position: relative;
  margin-bottom: 100px;
}
.detail-introduce{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 660px;
  height: 122px;
  bottom: -100px;
  background: #FFFFFF;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 22px 50px 30px;
}
.detail-introduce-left-username {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 153%;
  /* identical to box height, or 37px */
  margin-right: 30px;
  color: #000000;
}
.detail-introduce-left-student{
  font-family: 'PingFang HK';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 153%;
  color: #898989;
}
.detail-introduce-right span{
font-family: 'PingFang HK';
font-style: normal;
font-weight: 400;
font-size: 28px;
line-height: 153%;
  color: #AB73A9;
}
.detail p img{
  padding: 0;
  width: 100%;
  display: block;
  height: auto;
}

.detail{
  padding-bottom: 200px;
  padding: 30px 40px 270px;
}
img{
  width: 100%;
  display: block;
  height: auto;
}
.detail p {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 64px;
  color: #887E89;
}
.detail img{
  padding-top: 10px !important;
}
.back{
  width: 80px;
  position: fixed;
  bottom: 0;
  left: 60px;
  z-index: 999;
}
.back span{
  display: block;
  font-size: 30px;
  color: #333333;
}
.backTo{
  position: absolute;
  left:34px;
  top:50px;
}
.backToImg{
  width:68px;
  height:68px;
}

</style>
<style scoped lang="scss">
.detail-content-wrapper{
  .iconfont{
    font-size: 26px;
    color:#A471AA;
  }
  .detail-donate-text{
    font-size: 34px;
  }
  .donation {
    width: 100%;
    height: 330px;
    box-sizing: border-box;
    padding:50px 80px;
    text-align: center;
    background-color: #FFFFFF;
    .donation-num{
      width: 100%;
      display: flex;
      justify-content: space-between;
      background-color: #F4F2F4;
      height: 100px;
      line-height: 100px;
      box-sizing: border-box;
      border-radius: 30px;
      padding: 0 40px;
      .donation-num-left{
        span{
          font-weight: 500;
          font-size: 30px;

        }
      }
      .donation-num-right{
        span{
          font-family: 'PingFang HK';
          font-style: normal;
          font-weight: 500;
          font-size: 40px;
          color: #312E31;
        }
      }
    }
    .donation-contract{
      margin-top: 40px;
      span{
        font-size: 28px;
      }
    }
    .submit{
      margin-top: 36px;
      text-align: center;
      width: 100%;
      height: 96px;
      line-height: 96px;
      background-color: #c996c9;
      color: #FFFFFF;
      border-radius: 50px;
      span{
        font-size: 34px;
      }
    }
  }
}
</style>
